// Must load before App (and client.js) so health checks use the configured API host.
import { DEFAULT_API_BASE_URL, normalizeApiBaseUrl } from './defaultApiUrl.js'

const apiBaseUrl = normalizeApiBaseUrl(
  import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL
)

globalThis.__API_BASE_URL__ = globalThis.__API_BASE_URL__ || apiBaseUrl
